import React from "react";
import { Container } from "react-bootstrap";

function Footer() {
  return (
    <footer className="text-white text-center py-3">
      <Container>
        <p>© 2025 Wengmack. All Rights Reserved.</p>
      </Container>
    </footer>
  );
}

export default Footer;
